module.exports = __webpack_public_path__ + "static/media/IMG_680x324px_Ilustration.dba61a37.svg";